import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export enum informationType {
    NO_MESSAGE,
    SESSION_EXPIRED,
    KEYCLOAK_NOT_INIT,
    API_DOWN,
}

@Component({
    selector: 'app-information-dialog',
    templateUrl: './information-dialog.component.html',
    styleUrls: ['./information-dialog.component.scss'],
    standalone: false
})
export class InformationDialogComponent {
    informationType = informationType;

    public data: informationType = inject(MAT_DIALOG_DATA);
    private dialogRef: MatDialogRef<InformationDialogComponent> = inject(
        MatDialogRef<InformationDialogComponent>
    );

    constructor() {}

    reloadPage() {
        window.location.reload();
        this.dialogRef.close(); // Close the dialog after reloading the page
    }
}
